export default "__VITE_ASSET__a3ce1839__"